// FILE: src/components/PasswordRules.jsx
// Live checklist of the password policy (MTO glossary "Strong Password").
// Each rule ticks as soon as it's met: a check or a cross plus the words
// "done" / "needed", never colour alone (WCAG 1.4.1).
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { PASSWORD_RULES } from "../utils/passwordPolicy";

export default function PasswordRules({ password = "", id = "password-rules" }) {
  return (
    <List dense id={id} aria-label="Password rules" data-testid="password-rules">
      {PASSWORD_RULES.map((r) => {
        const ok = r.test(password);
        return (
          <ListItem key={r.id} disableGutters data-met={ok ? "true" : "false"}>
            <ListItemIcon sx={{ minWidth: 32 }}>
              {ok ? (
                <CheckCircleIcon color="success" fontSize="small" aria-hidden />
              ) : (
                <CancelOutlinedIcon fontSize="small" aria-hidden sx={{ color: "text.secondary" }} />
              )}
            </ListItemIcon>
            <ListItemText primary={`${r.label} — ${ok ? "done" : "needed"}`} />
          </ListItem>
        );
      })}
    </List>
  );
}
